// Vendor
import { createSelector } from '@ngrx/store';
// Selectors
import { getChartState } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart-base.selectors';
export const getCorrelations = createSelector(getChartState, ({ correlations }) => correlations);
export const hasCorrelations = createSelector(getCorrelations, (correlations) => {
    return correlations && correlations.length;
});
export const getMaxCorrelationId = createSelector(getCorrelations, (correlations) => {
    return correlations.length === 0 ? -1 : Math.max(...correlations.map((correlation) => correlation.correlationId));
});
